// extracted by mini-css-extract-plugin
export default {"checkbox":"KI1Qqb14C0S+BKwPSjNqdQ==","controls":"--1vPVAMF358ILOxwZXURg==","back-button":"wBq0u8P2fqAz61hwKsgONg=="};